import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export default function PageSeo({
  title,
  description,
  keywords = [],
  path = "/",
  image = "/og-image.png",
  type = "website",
  siteName = "MotoHub India",
  author = "MotoHub India",
  ogImageAlt = "MotoHub India",
  twitterImage = image,
  twitterCard = "summary_large_image",
  schema = null,
  noindex = false,
}) {
  const fallbackSiteUrl = "https://motohubindia.com";
  const siteUrl =
    (typeof window !== "undefined" && window.location.origin) ||
    process.env.REACT_APP_SITE_URL ||
    fallbackSiteUrl;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const canonicalUrl = new URL(normalizedPath, siteUrl).toString();
  const imageUrl = image?.startsWith("http")
    ? image
    : new URL(image.startsWith("/") ? image : `/${image}`, siteUrl).toString();
  const twitterImageUrl = twitterImage?.startsWith("http")
    ? twitterImage
    : new URL(twitterImage.startsWith("/") ? twitterImage : `/${twitterImage}`, siteUrl).toString();
  const keywordsContent = Array.isArray(keywords) ? keywords.join(", ") : keywords;
  const robots = noindex
    ? "noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
  const jsonLd = schema || {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteName,
    url: siteUrl,
    description,
    inLanguage: "en-IN",
  };

  return (
    <Helmet>
      <html lang="en-IN" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywordsContent ? <meta name="keywords" content={keywordsContent} /> : null}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="theme-color" content="#e84c1e" />

      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={ogImageAlt} />
      <meta property="og:locale" content="en_IN" />
      <meta name="author" content={author} />

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twitterImageUrl} />
      <meta name="twitter:site" content="@motohubindia" />

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
